export default __webpack_public_path__ + "static/136-414ab72b7a19fc30e9651e0fabb9439b.jpg";